import axios from "axios";
import { useRouter } from "next/router";
import { useEffect } from "react";
import { connect } from "react-redux";
import Product from "../../components/ProductPage/Product";
import { route } from "next/dist/server/router";
import { setSelctedId } from "redux/actions/globalAction";
import Schemas from "../../layouts/schema.json";
import Head from "next/head";

const Service = ({ setSelctedId, ...props }) => {
  const {
    id,
    variantId,
    type,
    selectedCar,
    selectedWorkshop,
    globalData,
    metaTitle,
    metaDescription,
  } = props;
  const router = useRouter();

  useEffect(() => {
    const carData = JSON.parse(
      localStorage.getItem("car_data") || JSON.stringify("")
    );
    let immutableUrl = "/";
    let carSlug =
      carData && carData?.slug
        ? carData?.slug
        : carData?.brand && carData?.modal
        ? `${carData?.brand} ${carData?.modal}`
            .trim()
            .split(" ")
            .join("-")
            .toLowerCase()
            .split(".")
            .join("")
        : null;
    if (router.query?.slug) {
      router.query?.slug?.map((item, index) => {
        immutableUrl += index == 2 ? carSlug || "car" : item;
        immutableUrl += "/";
        return item;
      });
      if (router.query?.slug?.length <= 2) {
        immutableUrl += carSlug || "car";
      }
    } else {
      immutableUrl += `/${
        globalData.locationData?.data.EmirateAreaSlug || "dubai"
      }/${
        router.query?.slug?.length && router.query?.slug[1]
          ? router.query?.slug[1] + "/" + "dubai" + "/" + carSlug || "car"
          : "oil-change" + "/" + carSlug || "car"
      }`;
    }

    if (router.query && router.query?.variantId && router.query?.workshopId) {
      const variantId = router.query.variantId;
      const workshopId = router.query.workshopId;
      const brandId = router.query?.brandId;
      localStorage.setItem(
        "url_data",
        JSON.stringify({ variantId, workshopId, brandId })
      );
    }

    const isWorkshopUrl =
      router &&
      router.query &&
      router.query?.slug &&
      router.query?.slug?.length &&
      router.query?.slug[3];

    let isFirstJourneySteps;
    if (typeof window !== "undefined") {
      isFirstJourneySteps = localStorage.getItem("isFirstJourneySteps");
    }

    if (isWorkshopUrl && !isFirstJourneySteps) {
      sessionStorage.setItem("isWorkshopCollection", true);
      localStorage.removeItem("isFirstJourneySteps");
    }

    // if (router.query && router.query?.id) {
    //   immutableUrl += `?id=${router?.query?.id}`
    // }

    router.push(
      {
        pathname: `/services/[...slug]`,
      },
      "/services" + immutableUrl,
      { shallow: true }
    );
  }, []);

  useEffect(() => {
    if (id) {
      setSelctedId(id);
    }
  }, [id]);
  return (
    <>
      <Head>
        <title>{metaTitle}</title>
        <meta name="description" content={metaDescription} />
        <meta property="og:title" content={metaTitle} />
        <meta property="og:description" content={metaDescription} />
      </Head>
      <Product
        id={id}
        variantId={variantId}
        type={type}
        selectedCar={selectedCar}
        selectedWorkshop={selectedWorkshop}
      />
    </>
  );
};

export async function getServerSideProps({ params }) {
  let props = {
    id: 1,
    variantId: null,
    type: "UFJ",
    metaTitle: " Product - Open Bonnet ",
    metaDescription:
      "Book Oil Change with Open Bonnet – UAE's leading car service center. Trust our expert mechanics for high-quality, efficient automotive care.",
  };
  if (params?.slug[3]) {
    try {
      let workshopSlug = params?.slug[3];
      const { data: itemData } = await axios.get(
        `${process.env.NEXT_PUBLIC_API_URL}v2/api/workshops?slug=${workshopSlug}`,
        {
          headers: {},
        }
      );
      props.selectedWorkshop = itemData.Data;
    } catch (error) {
      console.log("eee ", error);
    }
  }
  if (params?.slug[2]) {
    try {
      let carSlug = params?.slug[2];
      const { data: itemCarData } = await axios.get(
        `${process.env.NEXT_PUBLIC_API_URL}v2/api/slugs/car-barand-model/${carSlug}`,
        {
          headers: {},
        }
      );
      props.selectedCar = itemCarData.Data;
    } catch (error) {
      // console.log("eeee ", error);
    }
  }
  if (params?.slug[1]) {
    let categorySlug = params?.slug[1];
    if (categorySlug.includes("service-contract")) {
      categorySlug = "service-contract";
    }
    const { data } = await axios.get(
      `${process.env.NEXT_PUBLIC_API_URL}v2/api/slugs/category-variant/${categorySlug}`,
      {
        headers: {},
      }
    );
    const Data = Schemas;
    Data.metaTags?.map((item) => {
      if (item.page == categorySlug) {
        props.metaTitle = item.title;
        props.metaDescription = item.description;
      }
    });
    if (data.Data) {
      props.id = data.Data.JouneryCategoryId;
      props.variantId = data.Data.JouneryVariantId;
      props.type = data.Data.JobSectionType;
    }
  }

  return {
    props,
  };
}

const mapStateToProps = (state) => {
  return {
    globalData: state.globalData,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    setSelctedId: (data) => {
      dispatch(setSelctedId(data));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Service);
